import 'jquery'
import 'sticksy'
import jquery from 'jquery'
const $ = jquery

export default class Sticky {
    start() {
        if (window.innerWidth > 1024) {
            if (document.querySelector('.js-sticky-widget')) {
                // @ts-ignore
                const stickyEl = new Sticksy('.js-sticky-widget', {
                    topSpacing: 147,
                })
            }

            console.log('[Sticky] bootsrap')
        }
    }
}
